<template>
  <div
    id="organization-selector"
    :class="{ 'dropdown--active': active }"
    class="dropdown dropdown--full">
    <button
      class="button button--pulsate u-border-radius"
      @click.prevent="toggle">
      <span
        class="button__text">{{ organizationType }}</span>
      <span
        class="button__icon"><i class="icon icon-small-triangle-down"/></span>
    </button>
    <div class="dropdown__menu u-border-radius">
      <div class="navlinks">
        <div
          v-for="(type, index) in types"
          :key="index"
          class="navlinks__item">
          <a
            href="#"
            data-scroll-ignore
            :data-type="type"
            class="navlinks__link"
            @click.prevent="selectType(type)">{{ type }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'cookies-js'

export default {
  data: () => ({
    types: [
      'Corporation',
      'Trade Publisher',
      'Association',
      'Event'
    ],
    active: false
  }),
  computed: {
    organizationType () {
      return Cookies.get('organization_type') || 'Corporation'
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.active = false
      }
    },
    toggle () {
      this.active = !this.active
    },
    selectType (type) {
      Cookies.set('organization_type', type)

      $('.br-features__item').toggleClass('br-features__item--flip')

      setTimeout(() => {
        this.reload()
      }, 200)
    }
  }
}
</script>
